import { render, staticRenderFns } from "./FlipkartReportCard.vue?vue&type=template&id=06c8ca48&lang=pug"
import script from "./FlipkartReportCard.vue?vue&type=script&lang=js"
export * from "./FlipkartReportCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports